import { Slider, SliderTrack } from './styles'

interface SliderProps {
  children: React.ReactNode
  isPaused?: boolean
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const SliderStyled = ({ children, isPaused = false, onMouseEnter, onMouseLeave }: SliderProps) => {
  return (
    <Slider onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <SliderTrack isPaused={isPaused}>{children}</SliderTrack>
    </Slider>
  )
}

export default SliderStyled
